import { hasValue } from '../helpers';
export class InMemorySession {
    static SESSION_PASSWORD_STORAGE_KEY = 'inMemorySessionPassword';
    storeAvailable() {
        return hasValue(window.AppDataStore);
    }
    getPassword() {
        if (!this.storeAvailable()) {
            return undefined;
        }
        const sessionPassword = window.AppDataStore.getValue(InMemorySession.SESSION_PASSWORD_STORAGE_KEY);
        return typeof sessionPassword === 'string' ? sessionPassword : undefined;
    }
    setPassword(password) {
        if (!this.storeAvailable()) {
            return;
        }
        window.AppDataStore.setValue(InMemorySession.SESSION_PASSWORD_STORAGE_KEY, password);
    }
    clearPassword() {
        this.setPassword(undefined);
    }
}
